import { ChevronLeft, ChevronRight } from "@mui/icons-material"
import { IconButton, Stack, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { useAppLocalization } from "../../../modules/localization/components/AppLocalizationProvider"

const useStyles = makeStyles()((theme) => ({
    navigationContainer: {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
}))

const counterTranslationIds = {
    receipt: "user-order-receipt-page-navigation-counter",
    slip: "production-package-slip-navigation-counter",
    pos: "user-pos-order-receipt-page-navigation-counter",
} as const

type ReceiptNavigationProps = Readonly<{
    isAuthenticated: boolean
    isSelectMode: boolean
    goToPreviousOrder: () => void
    goToNextOrder: () => void
    ordersLength: number
    currentMeetingIndex: number
    variant: keyof typeof counterTranslationIds
}>

export const ReceiptNavigation = ({
    isAuthenticated,
    isSelectMode,
    goToPreviousOrder,
    goToNextOrder,
    ordersLength,
    currentMeetingIndex,
    variant,
}: ReceiptNavigationProps) => {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()

    return (
        <Box className={classes.navigationContainer}>
            {isAuthenticated && !isSelectMode && ordersLength > 1 && (
                <Stack direction="row" gap="1rem" alignItems="center" justifyContent="center">
                    <IconButton
                        aria-label={l10n.getString("receipt-order-navigation-previous-button")}
                        onClick={goToPreviousOrder}
                        disabled={currentMeetingIndex === 0}
                    >
                        <ChevronLeft />
                    </IconButton>
                    <LocalizedStrict
                        id={counterTranslationIds[variant]}
                        vars={{ current: currentMeetingIndex + 1, total: ordersLength }}
                    >
                        <Typography>
                            Order {currentMeetingIndex + 1} of {ordersLength}
                        </Typography>
                    </LocalizedStrict>
                    <IconButton
                        aria-label={l10n.getString("receipt-order-navigation-next-button")}
                        onClick={goToNextOrder}
                        disabled={currentMeetingIndex === ordersLength - 1}
                    >
                        <ChevronRight />
                    </IconButton>
                </Stack>
            )}
        </Box>
    )
}
